import { ProviderName } from '../models/provider';

const getProviderDisplayName = (providerName: ProviderName):
    string => providerName === 'nativex' ? 'nativesquid' : providerName;

export {
    // eslint-disable-next-line import/prefer-default-export
    getProviderDisplayName,
};
